import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  constructor(private http: HttpClient) { }

  reorganize(dataIn) {

    let url = ENV.APP.BACKEND_API + '/exhibitors/' + dataIn.exhibitorId + CONSTANTS.END_POINTS.MEDIA.REORGANIZE;

    let reorganizeIn = dataIn.order;

    return this.http.put(url, reorganizeIn);

  }

  reorganizeProductImages(dataIn) {

    let url = ENV.APP.BACKEND_API + '/products/' + dataIn.productId + CONSTANTS.END_POINTS.MEDIA.REORGANIZE;

    let reorganizeIn = dataIn.order;

    return this.http.put(url, reorganizeIn);

  }

  addFile(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.MEDIA.ADD_FILE;

    const formData = new FormData();
    formData.append('file', dataIn.file);
    formData.append('catalogueId', dataIn.catalogueId);
    formData.append('name', dataIn.name);

    if (dataIn.exhibitorId) {
      formData.append('exhibitorId', dataIn.exhibitorId);
    } else if (dataIn.productId) {
      formData.append('productId', dataIn.productId);
    }

    return this.http.post(url, formData);

  }

  deleteFile(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.MEDIA.DELETE_FILE + '/' + dataIn.fileId;

    return this.http.delete(url, dataIn);

  }





}
